import { module } from "angular";
import comments from "@gtmhub/comments/module";
import insightsCore from "@gtmhub/insights/insights-core.module";
import { CloneOrMoveResourceService } from "@gtmhub/okrs/components/clone-okrs/clone-or-move-resource.service";
import okrViewsModule from "@gtmhub/okrs/okr-views/okr-views.module";
import onboardingCore from "@gtmhub/onboarding/onboarding-core.module";
import pluginsCore from "@gtmhub/plugins/plugins-core.module";
import gridFilteringBar from "@gtmhub/shared/components/grid-filtering-bar/grid-filtering-bar.module";
import hotkeys from "@gtmhub/shared/libs/angular-hotkeys/angular-hotkeys.module";
import { loadModuleStyles } from "@gtmhub/shared/ng-extensions/util";
import tagsCore from "@gtmhub/tags/tags-core.module";
import { GoalWorkflowStatusLabelComponent } from "@webapp/okrs/components/goal-workflow-status-label/goal-workflow-status-label.component";
import { GoalPrivacyButtonComponent } from "@webapp/okrs/goals/components/goal-privacy-button/goal-privacy-button.component";
import { OkrDesignScoreComponent } from "@webapp/okrs/goals/components/okr-design-score/okr-design-score.component";
import { CreateMetricFormComponent } from "@webapp/okrs/metrics/components/create-metric-form/create-metric-form.component";
import { MetricSnapshotsComponent } from "@webapp/okrs/metrics/components/metric-snapshots/metric-snapshots.component";
import { UpdateMetricNoteComponent } from "@webapp/okrs/metrics/components/update-metric-note/update-metric-note.component";
import goals from "../goals/goals.module";
import links from "../links/links.module";
import sessions from "../sessions/sessions.module";
import tasks from "../tasks/tasks.module";
import workflow from "../workflow/module";
import alignmentTree from "./alignment-tree/module";
import { CloneOkrsComponent, CloneOkrsModal } from "./components/clone-okrs/clone-okrs.component";
import metrics from "./metrics/metrics.module";
import moduleStyles from "./okrs.module.less";
import { Ng1ConfirmGoalDeleteService } from "./services/ng1-confirm-goal-delete.service";

const mod = module("okrs", [
  tagsCore,
  onboardingCore,
  sessions,
  goals,
  metrics,
  alignmentTree,
  pluginsCore,
  gridFilteringBar,
  insightsCore,
  tasks,
  workflow,
  links,
  comments,
  hotkeys,
  okrViewsModule,
]);

mod.component("cloneOkrs", CloneOkrsComponent);

mod.downgradeComponent("okrDesignScore", { component: OkrDesignScoreComponent, propagateDigest: false });
mod.downgradeComponent("goalPrivacyButton", { component: GoalPrivacyButtonComponent, propagateDigest: false });
mod.downgradeComponent("goalWorkflowStatusLabel", { component: GoalWorkflowStatusLabelComponent, propagateDigest: false });
mod.downgradeComponent("updateMetricNote", { component: UpdateMetricNoteComponent, propagateDigest: false });
mod.downgradeComponent("createMetricForm", { component: CreateMetricFormComponent, propagateDigest: false });
mod.service("Ng1ConfirmGoalDeleteService", Ng1ConfirmGoalDeleteService);
mod.downgradeComponent("ghMetricSnapshots", { component: MetricSnapshotsComponent, propagateDigest: false });

mod.service("CloneOkrsModal", CloneOkrsModal);
mod.service("CloneOrMoveResourceService", CloneOrMoveResourceService);

loadModuleStyles(mod, moduleStyles);

export default mod.name;
